module.exports = __webpack_public_path__ + "img/index-solutions-info.198afe70.png";